import { put, select, takeLatest } from 'redux-saga/effects';
import { get, identity } from 'lodash';
import { INIT_CARDS_FILTERS } from '../actions/actionTypes/filters';
import { getCurrentUserCardsIds } from '../../components/Metrics/PageConfigurations/helper';
import { getUser } from '../selectors/user';
import { getCardsConfig } from '../../components/Metrics/cardsConfigurationFactory';
import { CARD_FILTERS } from '../../utils/constants';
import { setCardsFilters } from '../actions/filters';
import { type RootState } from '../types';
import { type UserInterface } from '../../utils/types';

type SelectorFn = (state: RootState) => unknown;

export function* doCardsFilterInitialization(): Generator<any, void, any> {
    const user: UserInterface = yield select(getUser);
    const values: string[] = yield getCurrentUserCardsIds(user);
    const state: RootState = yield select(identity);

    const defaultCardFilters: Record<string, any> = {};
    values.forEach(cardId => {
        const config = getCardsConfig(cardId, user);
        if (!config) {
            return;
        }
        const cardFilters = config.filters;
        const cardFilterSelectors = config.filterSelectors;
        if (!cardFilters) {
            return;
        }
        defaultCardFilters[cardId] = {};

        Object.values(CARD_FILTERS).forEach(filter => {
            if (filter in cardFilters) {
                const selector = get(cardFilterSelectors, filter, identity) as SelectorFn;
                const stateSlice = selector(state);
                const { initialValue } = cardFilters[filter];
                defaultCardFilters[cardId][filter] = initialValue(stateSlice);
            }
        });
    });

    yield put(setCardsFilters(defaultCardFilters));
}

export function* onInitCardsFilter(): Generator<any, void, any> {
    yield takeLatest(INIT_CARDS_FILTERS, doCardsFilterInitialization);
}

export const cardsFiltersInitializer = [onInitCardsFilter()];
